import { Badge, Column, Row, Typography } from '@viewup/ui';
import type { PostCampaignCardProps } from 'app/viewing/_entities/post';
import {
  PostCampaignCard,
  PostCampaignCardStatus,
  PostCampaignStatus,
  postCampaignStatusLabel,
} from 'app/viewing/_entities/post';
import { SubmittedCard } from '../SubmittedCard';

type DeductCardProps = PostCampaignCardProps & {
  applicationDate: string;
  deductReason:
    | PostCampaignStatus.DEVIATION
    | PostCampaignStatus.NOT_SUBMITTED
    | PostCampaignStatus.REJECT;
  deductionAmount: number;
  rewardPoint: number;
};
export const DeductCard = (props: DeductCardProps) => {
  const { deductReason, applicationDate, deductionAmount, rewardPoint } = props;

  if (deductionAmount === 0) {
    return (
      <SubmittedCard
        status={PostCampaignStatus.EARNING_SUCCESS}
        {...props}
        earningPoint={rewardPoint}
      />
    );
  }

  return (
    <PostCampaignCard {...props}>
      <Badge
        colorVariant='danger'
        content={postCampaignStatusLabel[deductReason]}
        variant='rectangle'
      />
      <PostCampaignCard.Progress status={PostCampaignCardStatus.DEDUCT} />
      <PostCampaignCard.BottomContent gap={8}>
        <Column bgColor='bg.dangerSubtle' br={8} gap={8} px={12} py={8}>
          <Row alignItems='center' justifyContent='space-between'>
            <Typography color='text.tertiary' fontType='body2.regular'>
              신청일
            </Typography>
            <Typography color='text.danger' fontType='body2.regular'>
              {applicationDate}
            </Typography>
          </Row>
          <Row alignItems='center' justifyContent='space-between'>
            <Typography color='text.tertiary' fontType='body2.regular'>
              차감액
            </Typography>
            <Typography color='text.danger' fontType='body2.regular'>
              -{deductionAmount}P
            </Typography>
          </Row>
        </Column>
      </PostCampaignCard.BottomContent>
    </PostCampaignCard>
  );
};
